export default "__VITE_ASSET__d4367d92__"